// extracted by mini-css-extract-plugin
module.exports = {"container":"AddFeedbackDialog_container__sFPll","form":"AddFeedbackDialog_form__xvnLG"};